// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".frisbuy-marketplace-reviews,.frisbuy-marketplace-reviews *,.frisbuy-mobile-popup,.frisbuy-mobile-popup *,.frisbuy-mobile-review-sheet,.frisbuy-mobile-review-sheet *,.frisbuy-popup-review-post,.frisbuy-popup-review-post *{font-family:Gilroy,Segoe UI,Arial,sans-serif}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
